import React from 'react';  
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Stack, IconButton, useTheme } from '@mui/material';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { motion } from 'framer-motion';

function StickyFooter() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const backgroundColor = isDark ? '#152036' : '#ffffff';
  const borderColor = isDark ? '#1f2c45' : '#e5e7eb';
  const textColor = isDark ? '#cbd5e1' : '#4b5563'; // Tailwind gray-600 for light
  const iconColor = isDark ? '#ffffff' : '#ffffff';

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        maxWidth: 360,
        mx: 'auto',
        bgcolor: backgroundColor,
        boxShadow: isDark
          ? '0 -2px 16px rgba(47, 128, 237, 0.2)'
          : '0 -1px 10px rgba(0, 0, 0, 0.08)',
        borderTop: `1px solid ${borderColor}`,
        py: 0.8,
        px: 2,
        borderRadius: 3,
        zIndex: 1300,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
        {/* Left: Cards */}
        <motion.div
          whileTap={{ scale: 0.9 }}
          whileHover={{ scale: 1.08 }}
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >
          <IconButton 
          sx={{ color: textColor }} component={RouterLink} to="/cards">
            <CreditCardOutlinedIcon />
          </IconButton>
          <Typography variant="caption" sx={{ color: textColor, fontSize: '0.7rem' }}>
            Cards
          </Typography>
        </motion.div>

        {/* Center: Transfer */}
        <motion.div
          whileTap={{ scale: 0.95 }}
          whileHover={{ scale: 1.1 }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: -28,
          }}
        >
          <Box 
  sx={{
    width: 50,
    height: 50,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: isDark
      ? 'linear-gradient(135deg, #9B51E0, #2F80ED)'
      : '#2F80ED', // solid blue in light mode
    boxShadow: isDark
      ? '0 0 10px rgba(47, 128, 237, 0.4)'
      : '0px 3px 8px rgba(0, 0, 0, 0.1)',
  }}
>
  <IconButton 
  component={RouterLink}  
   to="/local-transfer"
    sx={{
      color: '#fff', // white icon in both modes
      width: 40,
      height: 40,
    }}
  >
    <CompareArrowsIcon />
  </IconButton>
</Box>
  <Typography variant="subtitle2" sx={{ color: '#fff', fontWeight: 'bold', mt: 0.5 }}></Typography>

          <Typography
            variant="caption"
            sx={{ color: isDark ? '#fff' : '#111827', fontSize: '0.7rem', mt: 0.5 }}
          >
            Transfer
          </Typography>
        </motion.div>

        {/* Right: My Account */}
        <motion.div
          whileTap={{ scale: 0.9 }}
          whileHover={{ scale: 1.08 }}
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >
          <IconButton sx={{ color: textColor }} component={RouterLink} to="/account-settings">
            <PersonOutlineOutlinedIcon />
          </IconButton>
          <Typography variant="caption" sx={{ color: textColor, fontSize: '0.7rem' }}>
            My Account
          </Typography>
        </motion.div>
      </Stack>
    </Box>
  );
}

export default StickyFooter;
